//region block: pre-declaration
//endregion
function checkOwnership(_this__u8e3s4, owner) {
  if (!(_this__u8e3s4.u1g_1 === owner))
    throw _this__u8e3s4;
}
//region block: exports
export {
  checkOwnership as checkOwnershipoyid8o0pxxr7,
};
//endregion

//# sourceMappingURL=FlowExceptions.common.mjs.map
